export class StringBuilder {
  private elements: string[] = [];
  private _length = 0;

  constructor() {}

  public append(...args: string[]): void {
    this.elements.push(...args);

    this.setLength(...args);
  }

  public appendLine(...args: string[]): void {
    this.append(...args, '\n');
  }

  public toString(): string {
    return this.elements.join('');
  }

  public get length(): number {
    return this._length;
  }

  private setLength(...args: string[]): void {
    args.forEach((a) => (this._length += a.length));
  }
}
